import React, { useState, useEffect } from 'react';
import './ExportDxfDialog.css';

const ExportDxfDialog = ({ isOpen, onClose, onExport, defaultFilename }) => {
  const [filename, setFilename] = useState(defaultFilename || 'drawing');
  const [isVisible, setIsVisible] = useState(false);
  const [isExporting, setIsExporting] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
      setIsExporting(false);
      // Açılışta dosya adını aktif pafta adına ayarla
      if (defaultFilename) setFilename(defaultFilename);
    } else {
      setIsVisible(false);
    }
  }, [isOpen, defaultFilename]);

  if (!isOpen) {
    return null;
  }

  const handleExport = () => {
    setIsExporting(true);
    // UI'nin loading durumunu renderlaması icin bir tick bekle
    setTimeout(() => {
      onExport(filename);
    }, 50);
  };

  return (
    <div className={`export-dxf-dialog-overlay ${isVisible ? 'visible' : ''}`} onClick={!isExporting ? onClose : undefined}>
      <div className="export-dxf-dialog" onClick={(e) => e.stopPropagation()}>
        {!isExporting ? (
          <>
            <div className="export-dxf-dialog-header">
              <h3>Export DXF</h3>
            </div>
            <div className="export-dxf-dialog-content">
              <label htmlFor="filename">Export Name</label>
              <input
                type="text"
                id="filename"
                value={filename}
                onChange={(e) => setFilename(e.target.value)}
                autoFocus
              />
            </div>
            <div className="export-dxf-dialog-actions">
              <button onClick={onClose} className="cancel-button">
                Cancel
              </button>
              <button onClick={handleExport} className="export-button">
                Export
              </button>
            </div>
          </>
        ) : (
          <div className="export-dxf-loading">
            <div className="export-dxf-loading-icon">
              <svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="#7aa6ff" strokeWidth="2" strokeLinecap="round">
                <path d="M12 3v6l3 3" />
                <circle cx="12" cy="12" r="9" strokeDasharray="56" strokeDashoffset="14">
                  <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="1s" repeatCount="indefinite" />
                </circle>
              </svg>
            </div>
            <p className="export-dxf-loading-text">DXF dosyasi hazirlaniyor...</p>
            <div className="export-dxf-progress-bar">
              <div className="export-dxf-progress-fill"></div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ExportDxfDialog;
